import React from "react";

export default function CreditType({
  elem,
  typeVisited,
  data,
  setTypeVisited,
  onChangeData,
}) {
  return (
    <div className="mb-2">
      <label for="nombre">{elem.label}</label>
      <select
        className={`${
          typeVisited ? (data?.entryType ? "" : "formError") : ""
        } selector form-select form-select-sm especialGroup shadow-sm formHover selectHeight`}
        name={elem.id}
        id={elem.id}
        onClick={() => setTypeVisited(true)}
        onChange={(e) => {
          onChangeData(e.target.value, e.target.id);
        }}
      >
        {elem.options.map((elem, index) => {
          return (
            <option key={index} value={elem?.value}>
              {elem?.option}
            </option>
          );
        })}
      </select>
    </div>
  );
}
